/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type AccountCompletionContainer_viewer = {
    readonly username: string | null;
    readonly email: string | null;
    readonly duplicateEmail: string | null;
    readonly profiles: ReadonlyArray<{
        readonly __typename: string;
    }>;
    readonly " $refType": "AccountCompletionContainer_viewer";
};
export type AccountCompletionContainer_viewer$data = AccountCompletionContainer_viewer;
export type AccountCompletionContainer_viewer$key = {
    readonly " $data"?: AccountCompletionContainer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountCompletionContainer_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AccountCompletionContainer_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duplicateEmail",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "profiles",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "CoralUser",
    "abstractKey": null
} as any;
(node as any).hash = 'decff12e5a9b3bfc9f64c1506b49d947';
export default node;
